module.exports = __webpack_public_path__ + "img/Loader.7130aab2.svg";